import { Waypoint } from 'react-waypoint';

import { Separator } from '@change/ds-core-ui/next';

import { SuggestedPetitionsLazy } from 'src/app/shared/components/suggestedPetitionsLazySunrise';

import { SiblingsNavigation } from './components/SiblingsNavigation';
import { usePageFooter } from './hooks/usePageFooter';

export function PageFooter() {
	const {
		data: { petitionId },
		actions: { handleSuggestedPetitionsPosition },
	} = usePageFooter();

	return (
		<div className="col-span-full m-4 md:my-12 xl:mx-0">
			<div>
				<SiblingsNavigation px={8} mb={32} />
				<Separator />
			</div>
			<Waypoint
				onPositionChange={({ currentPosition }) => handleSuggestedPetitionsPosition(currentPosition === 'below')}
			/>
			<div className="[&_*_.suggested-petitions-sunrise]:mx-auto [&_*_.suggested-petitions-sunrise]:px-0">
				<SuggestedPetitionsLazy channel="update_footer" sourceLocation="update_footer" petitionSlugOrId={petitionId} />
			</div>
		</div>
	);
}
